export const round = (input: number | string, precision = 2): string => {
  const number = typeof input === 'string' ? parseFloat(input) : input;
  const floatPrecision = 10 ** precision;
  return `${Math.round(number * floatPrecision) / floatPrecision}`;
};
